export { default as useScript } from './useScript';
export * from './useScript';
//# sourceMappingURL=index.js.map